module.exports = __webpack_public_path__ + "static/15-cdc5be25f046779845cc85a56a94cc30.png";